import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const DashboardPage = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirigir automáticamente a gestión de usuarios
    navigate("/user-management", { replace: true });
  }, [navigate]);

  return null;
};

export default DashboardPage;